export default {
  sm: `
  Separation of main and 
  server buildings for safety 
  and efficiency
  `,
  md: `
  Separation of main and 
  server buildings 
  for safety and efficiency
  `,
  lg: `
  Separation of main 
  and server buildings 
  for safety and 
  efficiency
  `
};
